import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from '../../App';

export default function AdminRoute() {
  const { currentUser } = useContext(UserContext);

  // 如果尚未登入，或是沒有 admin 權限，就導回首頁
  if (!currentUser || currentUser.profile?.role !== 'admin') {
    return <Navigate to="/browse" replace />;
  }

  return <Outlet />;
}
